export const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
width="18" height="24.888" viewBox="0 0 18 24.888">
<defs>
<clipPath id="clip-path">
<rect id="Rectangle_26854" data-name="Rectangle 26854" width="7.822" height="9.38" fill="#fff"/>
</clipPath>
</defs>
<g id="Group_20618" data-name="Group 20618" transform="translate(-1247 -844)">
<path id="Path_5624" data-name="Path 5624" d="M9,0a9.08,9.08,0,0,1,9,9.158c0,5.058-9.042,15.688-9,15.73.226,
0-9-10.672-9-15.73A9.08,9.08,0,0,1,9,0Z" transform="translate(1247 844)" fill="#435B37"/>
<g id="Group_20617" data-name="Group 20617" transform="translate(1252 850)">
<g id="Group_20017" data-name="Group 20017" transform="translate(0 -1)" clip-path="url(#clip-path)">
<path id="Path_4503" data-name="Path 4503" d="M2.534,8.2a.179.179,0,0,1-.179.179H.179A.179.179,0,0,1,0,
8.2V4.079a.3.3,0,0,1,.148-.257L3.763,1.735a.3.3,0,0,1,.3,0L7.673,3.822a.3.3,0,0,1,.148.257V8.2a.179.179,0,0,
1-.179.179H5.467A.18.18,0,0,1,5.288,8.2V5.6a.1.1,0,0,0-.052-.09L3.963,4.779a.1.1,0,0,0-.1,0l-1.273.735a.1.1,
0,0,0-.052.09ZM0,2.243v.026a.3.3,0,0,1,.148-.252L3.763-.07a.3.3,0,0,1,.3,0L7.673,2.017a.3.3,0,0,1,
.148.252V1.384a.3.3,0,0,0-.148-.257L4.059-.96a.3.3,0,0,0-.3,0L.148,1.127A.3.3,0,0,0,0,1.384" 
transform="translate(0 0.999)" fill="#fff"/>
</g>
</g>
</g>
</svg>`;

export const negPosIcon = (isNegative: boolean): string => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 100 100">
    <circle cx="50" cy="50" r="40" fill=${isNegative ? '#F72954' : '#18BF49'} />
  </svg>`;
};
